export default {"src":"/_next/static/image/public/images/flags/flag_299.14f3f3f72ff0d50a02f5d597680a6713.svg","height":16,"width":24};